import { render, staticRenderFns } from "./NCM.vue?vue&type=template&id=a845c6a0&"
import script from "./NCM.vue?vue&type=script&lang=js&"
export * from "./NCM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports